import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-render-error-message',
  imports: [],
  templateUrl: './render-error-message.component.html',
  styleUrl: './render-error-message.component.scss'
})
export class RenderErrorMessageComponent {
  @Input() title = '';
  @Input() message = '';
}
